import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { catchError, map, of, tap } from 'rxjs';
import { LoadingService } from '../loading/loading.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loading = inject(LoadingService);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    return true;
  }

  return authService.isUserLogedIn().pipe(
    tap(() => loading.show()),
    map((result: boolean) => {
      if (!result) {
        return router.createUrlTree(['/']);
      }
      return result;
    }),
    tap(() => loading.hide()),
    catchError((error) => {
      console.error('Error occurred:', error);
      return of(router.createUrlTree(['/']));
    }),
  );
};
